type Status =
  | "running"
  | "approval"
  | "takeover"
  | "failed"
  | "success"
  | "human"
  | "queued";

interface Props {
  status: Status;
  size?: number;
}

export function StatusDot({ status, size = 8 }: Props) {
  const bg: Record<Status, string> = {
    running: "var(--status-running)",
    approval: "var(--status-approval)",
    takeover: "var(--status-takeover)",
    failed: "var(--status-failed)",
    success: "var(--status-success)",
    human: "var(--status-human)",
    queued: "var(--status-queued)",
  };
  return (
    <span
      aria-hidden
      className={status === "running" ? "animate-pulse" : undefined}
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        display: "inline-block",
        background: bg[status],
        flexShrink: 0,
      }}
    />
  );
}
